import { StyledReview } from '@/components/styles';
import Icon from '@/assets/icons';

export default function Stars({ rating }) {
  const ratingNum = Number(rating) || 0;
  const stars = Array.from({ length: 5 }, (_, index) => index + 1);
  return (
    <StyledReview.Stars>
      {stars.map((star, ind) => {
        return <Icon key={ind} name="star" filled={star <= ratingNum} />;
      })}
    </StyledReview.Stars>
  );
}
